import { DimensionValue, Platform, StyleSheet } from 'react-native';

export default StyleSheet.create({
  accentBannerInnerContainer: {
    maxWidth: '100%',
  },
  accentBanner: {
    marginBottom: 32,
  },
  word: {
    textAlign: 'center',
    fontSize: 24,
    lineHeight: 32,
    marginVertical: 30,
  },
  image: {
    paddingBottom: Platform.select({
      web: (2 * 100) / 3 + '%',
    }) as DimensionValue,
    aspectRatio: 3 / 2,
    borderRadius: 2,
  },
  imagesContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  imageSet: {
    flexDirection: 'row',
  },
  cardWrapper: {
    marginHorizontal: Platform.select({
      web: 16,
      default: 10,
    }),
    marginBottom: Platform.select({
      web: 30,
      default: 20,
    }),
  },
});
